import * as _testnet from "./testnet/all";
const chains = [..._testnet.chains];
export default chains;
